import * as d3 from "d3";
import { Chart } from "./Chart";
// import i18n from '../lang/lang'

export function ChartBarStackedGroupedVertical(alias, chartData) {
  this.alias = alias;
  this.chartData = chartData;
  this.data = chartData.data;
  var chart = new Chart(alias);

  this.render = () => {
    var data = [];
    for (var i in this.data) {
      for (var j in this.data[i].data) {
        for (var k in this.data[i].data[j].group) {
          data.push({
            group: this.data[i].group,
            label: this.data[i].data[j].label,
            key: this.data[i].data[j].group[k].label,
            value: this.data[i].data[j].group[k].value,
          });
        }
      }
    }

    var x0 = d3
      .scaleBand()
      .rangeRound([0, chart.chartWidth])
      .paddingInner(0.05)
      .domain(
        data.map(function (d) {
          return d.group;
        })
      );

    var x1 = d3
      .scaleBand()
      .domain(
        data.map(function (d) {
          return d.label;
        })
      )
      .rangeRound([0, x0.bandwidth()])
      .padding(0.1);

    var y = d3.scaleLinear().rangeRound([chart.chartHeight, 0]);

    var z = d3.scaleOrdinal().domain(
      data.map(function (d) {
        return d.key;
      })
    );

    var stack = d3.stack().offset(d3.stackOffsetExpand);

    var keys = z.domain();

    var groupData = d3
      .nest()
      .key(function (d) {
        return d.label + d.group;
      })
      .rollup(function (d) {
        var d2 = { label: d[0].label, group: d[0].group };
        d.forEach(function (d) {
          d2[d.key] = d.value;
        });
        return d2;
      })
      .entries(data)
      .map(function (d) {
        return d.value;
      });

    var stackData = stack.keys(keys)(groupData);

    var g = chart.svg.append("g");

    var serie = g
      .selectAll(".serie")
      .data(stackData)
      .enter()
      .append("g")
      .attr("class", "serie")
      .attr("fill", (d) => {
        return chart.getColor(d.key);
      });

    serie
      .selectAll("rect")
      .data(function (d) {
        return d;
      })
      .enter()
      .append("rect")
      .attr("class", "serie-rect")
      .attr("transform", function (d) {
        return "translate(" + x0(d.data.group) + ",0)";
      })
      .attr("x", function (d) {
        return x1(d.data.label);
      })
      .attr("y", function (d) {
        return y(d[1]);
      })
      .attr("height", function (d) {
        return y(d[0]) - y(d[1]);
      })
      .attr("width", x1.bandwidth())
      .on("click", function (d, i) {
        console.log("serie-rect click d", i, d);
      });

    chart.drawAxis(x0, y, this.chartData.xAxis, this.chartData.yAxis);

    /* var legend = serie.append('g')
      .attr('class', 'legend')
      .attr('transform', function (d) {
        var dd = d[d.length - 1]
        return 'translate(' + (x0(dd.data.group) + x1(dd.data.label) + x1.bandwidth()) + ',' + ((y(dd[0]) + y(dd[1])) / 2) + ')'
      })

    legend.append('line')
      .attr('x1', -6)
      .attr('x2', 6)
      .attr('stroke', '#000')

    legend.append('text')
      .attr('x', 9)
      .attr('dy', '0.35em')
      .attr('fill', '#000')
      .style('font', '10px sans-serif')
      .text(function (d) { return d.key }) */
  };
}
